<script setup lang="ts">
import type {
  FamilyStatRow,
  SemesterColumn,
  TotalRow,
} from '@/stores/useSalesFamilyStatsStore'

withDefaults(
  defineProps<{
    semesters: SemesterColumn[]
    rows: FamilyStatRow[]
    totalRow: TotalRow
    firstColLabel?: string
    totalLabel?: string
  }>(),
  {
    firstColLabel: 'Famille',
    totalLabel: 'Total (toutes commandes)',
  },
)

const eur = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})
function fmt(n: number): string {
  return eur.format(n ?? 0)
}
</script>

<template>
  <div class="overflow-x-auto">
    <table class="table table-sm">
      <thead>
        <tr>
          <th class="sticky left-0 bg-base-100 z-10">{{ firstColLabel }}</th>
          <th v-for="s in semesters" :key="s.key" class="text-right whitespace-nowrap">{{ s.label }}</th>
          <th class="text-right font-semibold whitespace-nowrap">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.code" class="hover">
          <td class="sticky left-0 bg-base-100 z-10 font-medium">
            <span :class="{ 'italic text-base-content/60': row.code === '__none__' }">{{ row.label }}</span>
          </td>
          <td v-for="s in semesters" :key="s.key" class="text-right tabular-nums whitespace-nowrap">
            {{ fmt(row.bySemester[s.key]) }}
          </td>
          <td class="text-right font-semibold tabular-nums whitespace-nowrap">{{ fmt(row.total) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="bg-base-200 font-semibold">
          <td class="sticky left-0 bg-base-200 z-10">{{ totalLabel }}</td>
          <td v-for="s in semesters" :key="s.key" class="text-right tabular-nums whitespace-nowrap">
            {{ fmt(totalRow.bySemester[s.key]) }}
          </td>
          <td class="text-right tabular-nums whitespace-nowrap">{{ fmt(totalRow.total) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
